
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import React, { useEffect, useState } from "react";
import { getDataListRequest } from "../../api/controller/DashboardController";
import ReactApexChart from "react-apexcharts";
import ReactEcharts from "echarts-for-react";
import { Loader } from "../../custom/components/Loader";
import RaceTeeDistributionTable from "../../custom/components/RaceTeeDistributionTable";

const Home = () => {

    const [loading, setLoading] = useState(true)
    const [stats, setStats] = useState({})
    const [chartData, setChartData] = useState({})
    const [teeData, setTeeData] = useState({})
    const [raceTeeDistribution, setRaceTeeDistribution] = useState({})
    const [parsedChartData, setParsedChartData] = useState([])
    const [officialEventTeeStock, setOfficialEventTeeStock] = useState({});

    useEffect(()=>{
        async function getData(){
            setLoading(true)
            try {
                const data = await getDataListRequest();
                setStats(data.stats)
                setChartData(data.chartData)
                setTeeData(data.teesData)
                setRaceTeeDistribution(data.raceTeeDistribution || {})
                setOfficialEventTeeStock(data.officialEventTeeStock || {});
                
                // Debug logging
                console.log('Dashboard data received:', {
                    stats: data.stats,
                    chartData: data.chartData,
                    teeData: data.teesData,
                    raceTeeDistribution: data.raceTeeDistribution
                });
                
            } catch (error) {
                console.error('Error fetching dashboard data:', error);
            } finally {
                setLoading(false)
            }
        }
        getData()
        // eslint-disable-next-line
    }, [])

    useEffect(()=>{
        let issued = []
        let pending = []
        Object.keys(chartData).forEach((key)=>{
            issued.push(chartData[key].ISSUED)
            pending.push(chartData[key].PENDING)
        })
        setParsedChartData([
            { name: "ISSUED", data: issued },
            { name: "PENDING", data: pending },
        ])
    }, [chartData])
    

    const options = {
        chart: {
            toolbar: { show: false, },
        },
        plotOptions: {
            bar: { horizontal: false, columnWidth: "45%", endingShape: "rounded" },
        },
        dataLabels: { enabled: false },
        stroke: { show: true, width: 2, colors: ["transparent"] },
        colors: ["#34c38f", "#556ee6", "#f46a6a", "#f1c40f", "#3498db", "#1abc9c", "#9b59b6", "#e74c3c", "#2ecc71", "#34495e"],
        xaxis: {
            categories: Object.keys(chartData).map(k => `${k} (${((chartData[k]?.ISSUED || 0) + (chartData[k]?.PENDING || 0))})`),
        },
        yaxis: { title: { text: "Count", }, },
        grid: { borderColor: "#f1f1f1", },
        fill: { opacity: 1, },
        tooltip: {
            y: {
                formatter: function (val) {
                    return val;
                },
            },
        },
    };

    const bgColors = ['rgba(255, 99, 132, 0.8)','rgba(255, 206, 86, 0.8)','rgba(75, 192, 192, 0.8)','rgba(153, 102, 255, 0.8)','rgba(255, 159, 64, 0.8)','rgba(146, 43, 33, 0.8)','rgba(99, 57, 116, 0.8)','rgba(26, 82, 118, 0.8)','rgba(17, 120, 100, 0.8)','rgba(33, 97, 140, 0.8)','rgba(25, 111, 61, 0.8)','rgba(154, 125, 10, 0.8)','rgba(205, 97, 85, 0.8)','rgba(175, 122, 197, 0.8)','rgba(84, 153, 199, 0.8)','rgba(72, 201, 176, 0.8)','rgba(82, 190, 128, 0.8)','rgba(244, 208, 63, 0.8)','rgba(235, 152, 78, 0.8)','rgba(236, 112, 99, 0.8)','rgba(165, 105, 189, 0.8)','rgba(93, 173, 226, 0.8)','rgba(69, 179, 157, 0.8)','rgba(88, 214, 141, 0.8)','rgba(245, 176, 65, 0.8)','rgba(255, 99, 132, 0.8)','rgba(255, 206, 86, 0.8)','rgba(75, 192, 192, 0.8)','rgba(153, 102, 255, 0.8)','rgba(255, 159, 64, 0.8)','rgba(146, 43, 33, 0.8)','rgba(99, 57, 116, 0.8)','rgba(26, 82, 118, 0.8)','rgba(17, 120, 100, 0.8)','rgba(33, 97, 140, 0.8)','rgba(25, 111, 61, 0.8)','rgba(154, 125, 10, 0.8)','rgba(205, 97, 85, 0.8)','rgba(175, 122, 197, 0.8)','rgba(84, 153, 199, 0.8)','rgba(72, 201, 176, 0.8)','rgba(82, 190, 128, 0.8)','rgba(244, 208, 63, 0.8)','rgba(235, 152, 78, 0.8)','rgba(236, 112, 99, 0.8)','rgba(165, 105, 189, 0.8)','rgba(93, 173, 226, 0.8)','rgba(69, 179, 157, 0.8)','rgba(88, 214, 141, 0.8)','rgba(245, 176, 65, 0.8)','rgba(255, 99, 132, 0.8)','rgba(255, 206, 86, 0.8)','rgba(75, 192, 192, 0.8)','rgba(153, 102, 255, 0.8)','rgba(255, 159, 64, 0.8)','rgba(146, 43, 33, 0.8)','rgba(99, 57, 116, 0.8)','rgba(26, 82, 118, 0.8)','rgba(17, 120, 100, 0.8)','rgba(33, 97, 140, 0.8)','rgba(25, 111, 61, 0.8)','rgba(154, 125, 10, 0.8)','rgba(205, 97, 85, 0.8)','rgba(175, 122, 197, 0.8)','rgba(84, 153, 199, 0.8)'];
    const horizontalBarData = {
      grid: {
        zlevel: 0,
        x: 50,
        x2: 50,
        y: 30,
        y2: 30,
        borderWidth: 0,
        backgroundColor: "rgba(0,0,0,0)",
        borderColor: "rgba(0,0,0,0)",
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          crossStyle: {
            color: "#999",
          },
        },
      },
      color: ["#3c4ccf", "#02a499", "#38a4f8"],
      yAxis: [
        {
          show: false,
          type: "category",
          data: Object.keys(teeData),
          axisPointer: {
            type: "shadow",
          },
          axisLine: {
            lineStyle: {
              color: "#74788d",
            },
          },
          nameTextStyle: {
            width: '500'
          }
        },
      ],
      xAxis: [
        {
          type: "value",
          name: "Count",
          axisLine: {
            lineStyle: {
              color: "#74788d",
            },
          },
        },
      ],
      series: [
        { 
            name: "Available", 
            type: "bar", 
            data: Object.keys(teeData) instanceof Array ? [...Object.keys(teeData)?.map((k,e)=>({itemStyle: {color: bgColors[e % bgColors.length]}, value: teeData[k].Available}))] : [] , 
            stack: "stackbar",
            label: {
              show: true,
              position: 'insideLeft',
              color: 'white',
              formatter: params => params.name,
            },
        },
        { 
            name: "Sold", 
            type: "bar", 
            data: Object.keys(teeData) instanceof Array ? [...Object.keys(teeData)?.map((k,e)=>({itemStyle: {color: 'rgba(54, 162, 235, 0.8)'}, value: teeData[k].Sold || 0}))] : [] , 
            stack: "stackbar",
        },
      ],
      textStyle: {
        color: ["#74788d"],
      },
  }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Loader loading={loading} />
                    <Col>

                        <Row>
                            <Col md="6">
                                <Card className="mini-stats-wid mycard">
                                <CardBody>
                                    <div className="d-flex">
                                    <div className="flex-grow-1">
                                        <p className="text-muted fw-medium">PENDING KITS</p>
                                        <h4 className="mb-0">{stats?.PENDING || "-"}</h4>
                                        <div className="mt-2 d-flex align-items-center">
                                            <i className="mdi mdi-account-group text-info me-2"></i>
                                            <small className="text-muted">Club: {stats?.CLUB_PENDING || "0"}</small>
                                        </div>
                                    </div>
                                    <div className="avatar-sm rounded-circle bg-warning align-self-center mini-stat-icon">
                                        <span className="avatar-title rounded-circle bg-warning">
                                        <i
                                            className={"mdi mdi-progress-wrench font-size-24"}
                                        ></i>
                                        </span>
                                    </div>
                                    </div>
                                </CardBody>
                                </Card>
                            </Col>
                            <Col md="6">
                                <Card className="mini-stats-wid mycard">
                                <CardBody>
                                    <div className="d-flex">
                                    <div className="flex-grow-1">
                                        <p className="text-muted fw-medium">ISSUED KITS</p>
                                        <h4 className="mb-0">{stats?.ISSUED || "-"}</h4>
                                        <div className="mt-2 d-flex align-items-center">
                                            <i className="mdi mdi-account-check text-primary me-2"></i>
                                            <small className="text-muted">Club: {stats?.CLUB_ISSUED || "0"}</small>
                                        </div>
                                    </div>
                                    <div className="avatar-sm rounded-circle bg-success align-self-center mini-stat-icon">
                                        <span className="avatar-title rounded-circle bg-success">
                                        <i
                                            className={"mdi mdi-check font-size-24"}
                                        ></i>
                                        </span>
                                    </div>
                                    </div>
                                </CardBody>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12}>
                                <Card className="mb-0">
                                    <CardBody>
                                        <Loader loading={loading} size="top" />
                                        <h3 align="center">Race Kit Overview</h3>
                                        <ReactApexChart options={options} series={parsedChartData} type="bar" height={350} />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                        {/* Official Event Tee Stock Status */}
                        {officialEventTeeStock?.hasOfficialTee && (
                            <Row>
                                <Col xs={12}>
                                    <Card className="mb-0">
                                        <CardBody>
                                            <h3 align="center" className="mb-4">
                                                <i className="mdi mdi-tshirt-crew text-primary me-2"></i>
                                                Official Event Tee Stock Status
                                            </h3>
                                            <div className="d-flex justify-content-center align-items-center flex-wrap mb-3">
                                                <span className="d-inline-flex align-items-center me-3 mb-1">
                                                    <span className="rounded me-1" style={{width: 12, height: 12, backgroundColor: '#6c757d'}}></span>
                                                    <small className="text-muted">Sold</small>
                                                </span>
                                                <span className="d-inline-flex align-items-center me-3 mb-1">
                                                    <span className="rounded me-1" style={{width: 12, height: 12, backgroundColor: '#ffc107'}}></span>
                                                    <small className="text-muted">Race Kit (not issued)</small>
                                                </span>
                                                <span className="d-inline-flex align-items-center me-3 mb-1">
                                                    <span className="rounded me-1" style={{width: 12, height: 12, backgroundColor: '#0dcaf0'}}></span>
                                                    <small className="text-muted">RacKit (issued)</small>
                                                </span>
                                                <span className="d-inline-flex align-items-center mb-1">
                                                    <span className="rounded me-1" style={{width: 12, height: 12, backgroundColor: '#198754'}}></span>
                                                    <small className="text-muted">Remaining</small>
                                                </span>
                                            </div>

                                            {/* Individual Tee Variant Cards */}
                                            <Row>
                                                {officialEventTeeStock.variants?.map((variant, index) => (
                                                    <Col md={4} lg={3} xl={2} key={variant.id} className="mb-2">
                                                        <Card className="h-100 border-0 shadow-sm">
                                                            <CardBody className="p-2">
                                                                <div className="text-center mb-2">
                                                                    <h6 className="mb-0 text-primary fw-bold" style={{fontSize: '0.9rem'}}>
                                                                        {variant.sizeName || `Size ${variant.id}`}
                                                                    </h6>
                                                                </div>

                                                                <div className="row text-center g-1">
                                                                    <div className="col-4">
                                                                        <div className="p-1 bg-light rounded">
                                                                            <h6 className="mb-0" style={{fontSize: '0.9rem', color: '#6c757d'}}>{variant.sold}</h6>
                                                                            <small className="text-muted" style={{fontSize: '0.7rem'}}>Sold</small>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-4">
                                                                        <div className="p-1 bg-light rounded">
                                                                            <h6 className="mb-0 text-info" style={{fontSize: '0.9rem'}}>{variant.raceKitReserved + variant.raceKitIssued}</h6>
                                                                            <small className="text-muted" style={{fontSize: '0.7rem'}}>Kit</small>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-4">
                                                                        <div className="p-1 bg-light rounded">
                                                                            <h6 className="mb-0 text-success" style={{fontSize: '0.9rem'}}>{variant.remaining}</h6>
                                                                            <small className="text-muted" style={{fontSize: '0.7rem'}}>Left</small>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="mt-2">
                                                                    <div className="progress" style={{height: '6px'}}>
                                                                        <div 
                                                                            className="progress-bar" 
                                                                            style={{
                                                                                width: `${(variant.sold / variant.totalStock) * 100}%`,
                                                                                backgroundColor: '#6c757d'
                                                                            }}
                                                                            title={`Sold: ${variant.sold}`}
                                                                        ></div>
                                                                        <div 
                                                                            className="progress-bar bg-info" 
                                                                            style={{width: `${(variant.raceKitIssued / variant.totalStock) * 100}%`}}
                                                                            title={`Reserved and Issued: ${variant.raceKitIssued}`}
                                                                        ></div>
                                                                        <div 
                                                                            className="progress-bar bg-warning" 
                                                                            style={{width: `${((variant.raceKitReserved) / variant.totalStock) * 100}%`}}
                                                                            title={`Reserved but not Issued: ${variant.raceKitReserved}`}
                                                                        ></div>
                                                                        <div 
                                                                            className="progress-bar bg-success" 
                                                                            style={{width: `${(variant.remaining / variant.totalStock) * 100}%`}}
                                                                            title={`Remaining: ${variant.remaining}`}
                                                                        ></div>
                                                                    </div>
                                                                    <small className="text-muted" style={{fontSize: '0.7rem'}}>
                                                                        {((variant.remaining) / variant.totalStock * 100).toFixed(1)}% available
                                                                    </small>
                                                                </div>
                                                            </CardBody>
                                                        </Card>
                                                    </Col>
                                                ))}
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        )}

                        <Row>
                            <Col xs={12}>
                                <RaceTeeDistributionTable 
                                    data={raceTeeDistribution} 
                                    loading={loading} 
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12}>
                                <Card className="mb-0">
                                    <CardBody>
                                        <Loader loading={loading} size="top" />
                                        <h3 align="center">Stock Overview</h3>
                                        <ReactEcharts style={{ height: ((100+(Object.keys(teeData).length*50))+"px") }} option={horizontalBarData} />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                    </Col>
                </Container>
            </div>
        </React.Fragment>
        
    )
    
}

export default Home;

